import { ObjectIdOrString } from "@mysnowscape/snow-lib";
import { ObjectId } from "bson";

export function dateFromMongoId(
  id: ObjectId | string | ObjectIdOrString,
): Date {
  return new Date(parseInt(id.toString().substring(0, 8), 16) * 1000);
}
